import React from 'react'

const Footer = () => {

  return (<footer>&copy; 2021 Smart Time | SCN Profile</footer>)
  
}

export default Footer
